import "./GroupedNav.scss";
import type { FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { isNavItemActive, type NavGroup } from "./groupedNavConfig";
import NavIconGlyph from "./NavIconGlyph";

interface GroupedNavProps {
  groups: NavGroup[];
}

const GroupedNav: FC<GroupedNavProps> = ({ groups }) => {
  const { pathname } = useLocation();

  return (
    <nav className="grouped-nav" aria-label="Main">
      {groups
        .filter((group) => group.items.length > 0)
        .map((group) => (
          <div
            key={group.id}
            className="grouped-nav-group"
            data-testid={`nav-group-${group.id}`}
          >
            <span className="grouped-nav-caption">{group.caption}</span>
            <div className="grouped-nav-items">
              {group.items.map((item) => {
                const isActive = isNavItemActive(pathname, item);

                return (
                  <Link
                    key={item.id}
                    to={item.to}
                    className={`top-menu-item ${isActive ? "is-active" : ""}`}
                    aria-current={isActive ? "page" : undefined}
                  >
                    <NavIconGlyph icon={item.icon} />
                    <span
                      className="top-menu-item-label"
                      data-testid={`selection-menu-${item.label}`}
                    >
                      {item.label}
                    </span>
                  </Link>
                );
              })}
            </div>
          </div>
        ))}
    </nav>
  );
};

export default GroupedNav;
